// 时间报表折线图选项
export const initOptions = [
  { name: '体验课支付人数', value: 'sum_l1_num' },
  { name: '续报人数', value: 'sum_renewal_num' },
  { name: '续报率', value: 'sum_renewal_rate' },
  { name: '公众号关注人数', value: 'sum_fans_num' },
  { name: '公众号关注率', value: 'sum_fans_rate' },
  { name: '微信添加人数', value: 'sum_wx_num' },
  { name: '微信添加率', value: 'sum_wx_rate' },
  { name: '首课到课人数', value: 'sum_0att_num' },
  { name: '首课到课率', value: 'sum_0att_rate' },
  { name: '首课完课人数', value: 'sum_0fin_num' },
  { name: '首课完课率', value: 'sum_0fin_rate' },
  { name: '全部课完课人数', value: 'sum_finish_num' },
  { name: '全部课完课率', value: 'all_finish_rate' }
]

// 时间报表表头
export const initColumns = [
  { label: '重购人数', prop: 'sum_repeat_num' },
  { label: '公众号关注人数', prop: 'sum_fans_num' },
  { label: '公众号关注率', prop: 'sum_fans_rate' },
  { label: '微信添加人数', prop: 'sum_wx_num' },
  { label: '微信添加率', prop: 'sum_wx_rate' },
  { label: '客户端登录人数', prop: 'sum_device_num' },
  { label: '客户端登录率', prop: 'sum_device_rate' },
  { label: '首课到课人数', prop: 'sum_0att_num' },
  { label: '首课到课率', prop: 'sum_0att_rate' },
  { label: '首课完课人数', prop: 'sum_0fin_num' },
  { label: '首课完课率', prop: 'sum_0fin_rate' },
  { label: '2课到课人数', prop: 'sum_1att_num' },
  { label: '2课到课率', prop: 'sum_1att_rate' },
  { label: '2课完课人数', prop: 'sum_1fin_num' },
  { label: '2课完课率', prop: 'sum_1fin_rate' },
  { label: '3课到课人数', prop: 'sum_2att_num' },
  { label: '3课到课率', prop: 'sum_2att_rate' },
  { label: '3课完课人数', prop: 'sum_2fin_num' },
  { label: '3课完课率', prop: 'sum_2fin_rate' },
  { label: '4课到课人数', prop: 'sum_3att_num' },
  { label: '4课到课率', prop: 'sum_3att_rate' },
  { label: '4课完课人数', prop: 'sum_3fin_num' },
  { label: '4课完课率', prop: 'sum_3fin_rate' },
  { label: '5课到课人数', prop: 'sum_4att_num' },
  { label: '5课到课率', prop: 'sum_4att_rate' },
  { label: '5课完课人数', prop: 'sum_4fin_num' },
  { label: '5课完课率', prop: 'sum_4fin_rate' },
  { label: '全部课到课人数', prop: 'sum_attend_num' },
  { label: '全部课到课率', prop: 'all_attend_rate' },
  { label: '全部课完课人数', prop: 'sum_finish_num' },
  { label: '全部课完课率', prop: 'all_finish_rate' },
  { label: '续报人数', prop: 'sum_renewal_num' },
  { label: '续报率', prop: 'sum_renewal_rate' },
  { label: '重购续报数', prop: 'sum_repeat_renewal_num' },
  { label: '重购续报率', prop: 'sum_repeat_renewal_rate' },
  { label: '续报金额', prop: 'sum_order_amount' }
]

// 订单维度报表表头
export const initOrderColumns = [
  { label: '来量', prop: 'sum_l1_num' },
  { label: '首次购买来量', prop: 'sum_first_num' },
  { label: '重复购买来量', prop: 'sum_repeat_num' },
  { label: '加微数', prop: 'sum_wx_num' },
  { label: '加微率', prop: 'sum_wx_rate' },
  { label: '关注公众号量', prop: 'sum_fans_num' },
  { label: '关注公众号率-订单', prop: 'sum_fans_rate' },
  { label: '有效登录客户端量', prop: 'sum_device_num' },
  { label: '有效登录客户端率', prop: 'sum_device_rate' },
  { label: '准备课到课量', prop: 'sum_0att_num' },
  { label: '准备课到课率', prop: 'sum_0att_rate' },
  { label: '首课到课量', prop: 'sum_1att_num' },
  { label: '2课到课量', prop: 'sum_2att_num' },
  { label: '3课到课量', prop: 'sum_3att_num' },
  { label: '4课到课量', prop: 'sum_4att_num' },
  { label: '首课到课率', prop: 'sum_1att_rate' },
  { label: '2课到课率', prop: 'sum_2att_rate' },
  { label: '3课到课率', prop: 'sum_3att_rate' },
  { label: '4课到课率', prop: 'sum_4att_rate' },
  { label: '准备课完课量', prop: 'sum_0fin_num' },
  { label: '准备课完课率', prop: 'sum_0fin_rate' },
  { label: '首课完课量', prop: 'sum_1fin_num' },
  { label: '首课完课率', prop: 'sum_1fin_rate' },
  { label: '2课完课量', prop: 'sum_2fin_num' },
  { label: '2课完课率', prop: 'sum_2fin_rate' },
  { label: '3课完课量', prop: 'sum_3fin_num' },
  { label: '3课完课率', prop: 'sum_3fin_rate' },
  { label: '4课完课量', prop: 'sum_4fin_num' },
  { label: '4课完课率', prop: 'sum_4fin_rate' },
  { label: '续报年课量（不含退费）', prop: 'l1_renewal_annual_ord_cnt' },
  { label: '完课续报率（不含退费）', prop: 'fin_l1_renewal_ord_rate' },
  { label: '续报数（不含退费）', prop: 'l1_renewal_ord_cnt' },
  { label: '续报率（不含退费）', prop: 'l1_renewal_ord_rate' }
]

export function handlePrompt(str) {
  let name = ''
  switch (str) {
    case '重购人数':
      name = '体验课触发了重复购买的用户数'
      break;
    case '重购续报数':
      name = '体验课触发了重复购买的用户中，续报了精品课的用户数'
      break;
    case '重购续报率':
      name = '重购续报人数/体验课支付人数'
      break;
    case '体验课支付人数':
      name = '仅包含已支付人数，剔除已退费人数'
      break;
    case '公众号关注率':
      name = '公众号关注率 = 公众号关注人数 / 体验课支付人数'
      break;
    case '微信添加率':
      name = '微信添加率 = 微信添加人数 / 体验课支付人数'
      break;
    case '客户端登录率':
      name = '客户端登录率 = 客户端登录人数 / 体验课支付人数'
      break;
    case '首课到课率':
      name = '首课到课率 = 首课到课人数 / 体验课支付人数'
      break;
    case '首课完课率':
      name = '首课完课率 = 首课完课人数 / 体验课支付人数'
      break;
    case '2课到课率':
      name = '2 课到课率 = 第 2 课到课人数 / 体验课支付人数'
      break;
    case '2课完课率':
      name = '2 课完课率 = 第 2 课完课人数 / 体验课支付人数'
      break;
    case '3课到课率':
      name = '3 课到课率 = 第 3 课到课人数 / 体验课支付人数'
      break;
    case '3课完课率':
      name = '3 课完课率 = 第 3 课完课人数 / 体验课支付人数'
      break;
    case '4课到课率':
      name = '4 课到课率 = 第 4 课到课人数 / 体验课支付人数'
      break;
    case '4课完课率':
      name = '4 课完课率 = 第 4 课完课人数 / 体验课支付人数'
      break;
    case '5课到课率':
      name = '5 课到课率 = 第 5 课到课人数 / 体验课支付人数'
      break;
    case '5课完课率':
      name = '5 课完课率 = 第 5 课完课人数 / 体验课支付人数'
      break;
    case '全部课完课人数':
      name = '全部课程每节都完课的人数，不等于最后一课的完课人数'
      break;
    case '全部课完课率':
      name = '全部课完课率 = 全部课完课人数 / 体验课支付人数'
      break;
    case '续报人数':
      name = '购买精品课的人数'
      break;
    case '续报率':
      name = '续报率 = 续报人数 / 体验课支付人数'
      break;
    case '续报截止占比':
      name = '续报截止占比 = 已经续报截止的人数 / 体验课支付人数'
      break;
    case '续报金额':
      name = '年课学费实际总收入（如过消费者使用了减免红包200元，则该单收入2499元'
      break;
    default:
      name = str
      break;
  }
  return name
}
